module.exports = __webpack_public_path__ + "static/sba-7f1f7a1c459317013dff026a478992f7.png";